@use "../../styles/breakpoint.module.scss" as *;

.inner {
    height: calc(
        100dvh - var(--top-nav-height, 0px) - var(
                --overlappable-nav-height,
                56px
            ) - var(--pdp-scroll-nav-height, 0px)
    );
}

.media {
    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: var(--overlay-black-gradient-horizontal);
        pointer-events: none;

        @media ($below-mobile) {
            background: var(--overlay-black-gradient);
            scale: 1 -1;
        }
    }
}

.content {
    flex-direction: column;
    gap: var(--spacer-16);
    align-items: flex-start;
    padding-block: var(--spacer-32);
}

.sku {
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    margin: 0;
}

.title {
    font: var(--font-h-40);
    margin: 0;
}

.actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--spacer-16);
}

.showroomButton {
    display: inline-flex;
    align-items: center;
    gap: var(--spacer-8);
}

.favoritesToggle {
    display: flex;
    align-items: center;
    gap: var(--spacer-4);
    font: var(--font-text-link-14);
    text-decoration: underline;
}

.favoritesToggleSvg {
    fill: currentColor;
    width: 14px;
    height: 13px;
}
